export enum todoPremiumTypes {
    FETCH_TODO_PREMIUM_REQUEST = 'FETCH_TODO_PREMIUM_REQUEST',
    EDIT_TODO_PREMIUM_REQUEST = 'EDIT_TODO_PREMIUM_REQUEST',
    SET_TODO_PREMIUM = 'SET_TODO_PREMIUM',
}
